import "./src/app";

